import { Input } from 'antd';
import { memo, type ReactElement, type ReactNode } from 'react';
import styled from 'styled-components';
import { StyledFormItem } from './FormItem';

export interface InputGroupProps {
    label?: string;
    children: ReactElement | ReactNode;
    required?: boolean;
}

const StyledInputGroup = styled(Input.Group)`
    display: flex;

    & .ant-form-item {
        flex-grow: 1;
    }
`;

const InputGroup = ({ label, required, children }: InputGroupProps) => (
    <StyledFormItem label={label} name="" required={required} style={{ marginBottom: 0 }}>
        <StyledInputGroup>{children}</StyledInputGroup>
    </StyledFormItem>
);

export default memo(InputGroup);
